import { useState } from "react";
import { ChevronDown } from "lucide-react";

const AssetList = ({
  ownedAssets,
  network,
  handleSelect,
  handleSelectNet,
  hotActionAsset,
}) => {
  const [showNetwork, setShowNetwork] = useState({});
  const handleNetwork = (assetId) => {
    setShowNetwork((prevState) => ({
      ...prevState,
      // eslint-disable-next-line security/detect-object-injection
      [assetId]: !prevState[assetId],
    }));
  };

  return (
    <div>
      {ownedAssets ? (
        ownedAssets?.map((asset) => {
          const assetNetworks = network?.filter(
            (net) => net?.assetId === asset.assetId
          );

          return (
            <div key={asset?.assetId} className="mb-4">
              <div
                className={`border border-gray-300 p-3 flex justify-between items-center cursor-pointer hover:bg-gray-100 transition
                rounded-lg
                ${showNetwork[asset?.assetId] ? "rounded-b-none" : ""}`}
                // onClick={() => handleSelect(asset)}
              >
                <div className="flex gap-3 items-center">
                  <img
                    src={asset?.assetIcon}
                    alt={asset?.assetName}
                    width={32}
                    height={32}
                    className="rounded-full"
                  />
                  <div>
                    <span className="text-gray-800 font-semibold">
                      {asset?.asset.toUpperCase()}
                    </span>
                    <span
                      onClick={() => {
                        handleNetwork(asset?.assetId);
                        handleSelect(asset);
                      }}
                      className="ml-4 inline-flex items-center gap-x-1.5 py-0.2 px-3 rounded-full text-xs font-medium bg-gray-100 text-gray-700 cursor-pointer"
                    >
                      Network
                      <ChevronDown className="text-gray-300" />
                    </span>
                    <p className="text-sm text-gray-600">{asset?.assetName}</p>
                  </div>
                </div>
                <div className="font-semibold">
                  {asset?.asset?.toUpperCase() === "BTC"
                    ? asset?.availableAmount.toFixed(6)
                    : asset?.availableAmount.toFixed(2)}
                </div>
              </div>

              <div
                className={`transition-all duration-300 ease-in-out ${
                  showNetwork[asset?.assetId]
                    ? "max-h-[1000px] opacity-100"
                    : "max-h-0 opacity-0"
                } overflow-hidden`}
              >
                {assetNetworks.map((net, index) => (
                  <div
                    key={net?._id}
                    onClick={() => handleSelectNet(net)}
                    className={`border border-t-0 p-3 flex justify-between items-center cursor-pointer hover:bg-gray-100 transition
                    ${index === assetNetworks.length - 1 ? "rounded-b-lg" : ""} 
                    ${index > 0 ? "-mt-px" : ""} 
                  `}
                  >
                    <div className="flex gap-3 items-center">
                      <img
                        src={asset?.assetIcon}
                        alt={asset?.assetName}
                        width={32}
                        height={32}
                        className="rounded-full"
                      />

                      <div className="text-left">
                        <div className="font-semibold">{net?.chain}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })
      ) : (
        <p>No assets found</p>
      )}
    </div>
  );
};

export default AssetList;
